export default __webpack_public_path__ + "static/media/call_end.b12348f3.svg";